
/**
 * Standard event names for analytics tracking
 */
export const AnalyticsEvents = {
  // Page views
  PAGE_VIEW: 'page_view',
  
  // Auth events
  LOGIN: 'login',
  LOGIN_WITH_GOOGLE: 'login_with_google',
  SIGNUP: 'signup',
  LOGOUT: 'logout',
  
  // Connection events
  CONNECTION_CREATED: 'connection_created',
  CONNECTION_QR_GENERATED: 'connection_qr_generated',
  CONNECTION_PAIRED: 'connection_paired',
  CONNECTION_FAILED: 'connection_failed',
  CONNECTION_RECONNECT_ATTEMPT: 'connection_reconnect_attempt',
  CONNECTION_RECONNECT_SUCCESS: 'connection_reconnect_success',
  
  // Message events
  MESSAGE_FLAGGED: 'message_flagged',
  MESSAGE_REVIEWED: 'message_reviewed',
  
  // User engagement
  BUTTON_CLICK: 'button_click',
  FEATURE_USED: 'feature_used',
  LINK_CLICK: 'link_click',
  VIEW_ALERTS_DASHBOARD_CLICK: 'view_alerts_dashboard_click',
  
  // Custom events
  CUSTOM: 'custom_event',
};

/**
 * Common parameter names for analytics events
 */
export const AnalyticsParams = {
  BUTTON_NAME: 'button_name',
  FEATURE_NAME: 'feature_name',
  LINK_URL: 'link_url',
  AUTH_METHOD: 'auth_method',
  CONNECTION_ID: 'connection_id',
  CONNECTION_NAME: 'connection_name',
  RECONNECT_ATTEMPT: 'reconnect_attempt',
  ERROR_MESSAGE: 'error_message',
  MESSAGE_TYPE: 'message_type',
  CONVERSATION_TYPE: 'conversation_type',
  SUCCESS: 'success',
  AGE_RATING: 'age_rating',
  NEW_CONNECTION_ID: 'new_connection_id',
};
